import React, { Component } from 'react'

import { INTERVALO_LARGO } from '../../../../../config/settings'
import { Toast } from 'react-bootstrap'
import { connect } from 'react-redux'
import { COLORES } from '../../../../../config/colores'

class ToastsContainer extends Component {
  render () {
    const { toasts } = this.props
    const toRender = []
    toasts.forEach(toast => {
      const backgroundColor = toast.error ? COLORES.error : COLORES.success
      toRender.push(
        <Toast onClose={toast.onClose}
          show={toast.show}
          delay={INTERVALO_LARGO}
          autohide
          style={{
            backgroundColor: backgroundColor
          }}
          key={toast.id}>
          <Toast.Header closeButton >
            <strong>{toast.title}</strong>
          </Toast.Header>
          <Toast.Body >
            <h5>{toast.message && toast.message}</h5>
            {toast.extraMessage && toast.extraMessage}
          </Toast.Body>
        </Toast>
      )
    })
    return <div
      style={{
        position: 'absolute',
        top: 10,
        right: 10,
        zIndex: 9999,
        opacity: 0.75
      }}
    >{toRender}</div>
  }
}
const mapStateToProps = (state) => {
  return {
    toasts: state.toasts.toasts
  }
}

export default connect(mapStateToProps)(ToastsContainer)
